module.exports = __webpack_public_path__ + "static/img/businesskit-header-modal.3b42d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/businesskits/businesskit-header-modal.png
// module id = 1421
// module chunks = 0